var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('chrome-picker',{staticClass:"color-pickr",staticStyle:{"box-shadow":"none","border":"1px solid #ddd"},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}}):_c('slider-picker',{model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }